import socialsHandle from "fragments/socialsHandle"
import gql from "graphql-tag"

const GET_SOCIALS_HANDLES_WAVE = gql`
  ${socialsHandle}

  query getSocialsHandlesWave($query: GetWaveQuerySocialsHandles!) {
    getSocialsHandlesWave(query: $query) {
      cursor
      prevCursor
      hasNextData
      hasPrevData
      handles {
        ...SocialsHandle
      }
    }
  }
`

export default GET_SOCIALS_HANDLES_WAVE
